<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link to="/">O.S.A.C.E.</router-link>
    </div>
    <div class="navbar-links">
      <router-link to="/news-feed">Noutăți</router-link>
      <router-link to="/">Evenimente</router-link>
      <router-link to="/my-events">Evenimentele Mele</router-link>
      <router-link to="/history">Istoric Ore</router-link>

            <div v-if="userRole === 'admin' || userRole === 'coordonator'" class="admin-links">
   
               <router-link v-if="userRole === 'admin'" to="/admin/users">Management Useri</router-link>
 
                <router-link to="/admin/events">Management Evenimente</router-link>

                <router-link to="/admin/create-post">Adaugă Postare</router-link>
 
                <router-link v-if="userRole === 'admin'" to="/admin/notify">Trimite Notificări</router-link>
       </div>
    </div>
    <div class="navbar-actions">
      <span v-if="userName">Salut, {{ userName }}</span>
      <button @click="handleLogout" class="logout-button">Logout</button>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const userName = ref('');
const userRole = ref('');

// Preluăm datele user-ului din localStorage pentru a afișa numele și link-urile de admin
onMounted(() => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      userName.value = userData.full_name;
      userRole.value = userData.role;
    }
  } catch (e) {
    console.error("Eroare la parsarea datelor user-ului in Navbar:", e);
  }
});

const handleLogout = () => {
  localStorage.removeItem('userToken');
  localStorage.removeItem('user');
  router.push({ name: 'Login' });
};
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0E3035; /* Albastru Închis OSACE */
  color: white;
  padding: 15px 30px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.navbar-brand a {
  font-size: 1.5em;
  font-weight: bold;
  color: white;
  text-decoration: none;
}

.navbar-links {
  display: flex;
  gap: 20px;
}

.navbar-links a,
.admin-links a {
  color: white;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.navbar-links a.router-link-exact-active {
  background-color: #1C748C; /* Albastru Deschis OSACE */
}

.admin-links {
  display: flex;
  gap: 20px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #1C748C;
}
.admin-links a.router-link-exact-active {
  background-color: #a04f46; /* O nuanță de roșu/accent */
}


.navbar-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logout-button {
  background-color: #C0392B; /* Roșu Accent OSACE */
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
.logout-button:hover {
  background-color: #a32e22;
}

/* ########################################## */
/* ## STILURI PENTRU TELEFON MOBIL (NOU)
/* ########################################## */
@media (max-width: 768px) {
  .navbar {
    /* Facem bara de navigare verticală */
    flex-direction: column;
    align-items: flex-start; /* Aliniem totul la stânga */
    padding: 15px;
  }

  .navbar-links {
    /* Facem link-urile verticale */
    flex-direction: column;
    width: 100%;
    margin-top: 15px; /* Spațiu sub brand */
  }

  .navbar-links a,
  .admin-links a {
    /* Facem link-urile să ocupe toată lățimea */
    width: 100%;
    box-sizing: border-box; /* Ca să includă padding-ul */
    text-align: left;
    padding: 10px 15px;
  }

  .admin-links {
    /* Scoatem bordura și spațierea */
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    width: 100%;
    gap: 0; /* Scoatem gap-ul dintre link-uri */
  }

  .navbar-actions {
    /* Mutăm "Salut, Nume" și "Logout" la sfârșit */
    width: 100%;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #1C748C; /* Linie de separare */
    justify-content: space-between; /* Întindem elementele */
  }
}
</style>